import { RampWithNameTransform } from '@goldwasserexchange/react-topmodel';
import * as React from 'react';
import { useTitleRampNames } from '../../../shared/useTitleRampNames';
export var TableFooterCellBase = function () {
    var _a = useTitleRampNames('FooterCellContainer', null), containerRampName = _a.rampName, containerRampFallbacks = _a.rampFallbacks;
    var _b = useTitleRampNames('FooterCellContent', null), contentRampName = _b.rampName, contentRampFallbacks = _b.rampFallbacks;
    return (React.createElement(RampWithNameTransform, { rampName: containerRampName, rampFallbacks: containerRampFallbacks },
        React.createElement(RampWithNameTransform, { rampName: contentRampName, rampFallbacks: contentRampFallbacks })));
};
